<template>
  <el-row :gutter="15" class="wrapper">
    <template v-for="(state) in [
        'sew_completed',
      ]">
      <el-col :md="8" :key="state">
        <div class="card section">
          <p class="page-title">{{$t(`productDesign.states.${state}`)}}</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'product_designs.index', query: { state_in: [state] } }">
                <p class="value">{{ data[`product_design_${state}_count`] || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
    </template>
  </el-row>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class CraftsmanHome extends Vue {
  data = {};

  async mounted() {
    this.data = await this.$request.get('/dashboard/plate_reviewer')
  }
}
</script>
